:host{display:flex;flex-direction:column;height:100%}app-add-edit-team{flex:1}
/*# sourceMappingURL=new-project-team-members.component-XWK2ST3E.css.map */
